<button
  class="collapse-button {{ direction }}"
  (click)="toggleCollapse()">
  @if (title && isCollapsed) {
    <span class="title">{{ title }}</span>
  }
  <mat-icon [class.inverted]="isCollapsed">{{ icon }}</mat-icon>
</button>
<ng-content></ng-content>
